export default "__VITE_ASSET__DCXeiV3N__"